import { Icon } from '@testsigma/atoms';

const DeleteConnectionModalHeader: React.FC = () => {
  return (
    <div className=' h-12 w-12 rounded-full border-spacing-2.5 bg-error-50 flex items-center justify-center'>
      <Icon
        name='error'
        className='flex text-2xl text-error-600 p-1 bg-error-100 rounded-full'></Icon>
    </div>
  );
};

export { DeleteConnectionModalHeader };
